<template>
  <slot name="header">
    <HeaderFocus>
      <slot name="header-content" />
    </HeaderFocus>
  </slot>
  <main id="hoved">
    <slot />
  </main>
</template>
